<div *ngIf="isOpen" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
  <!-- Backdrop -->
  <div
    class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
    (click)="onBackdropClick()">
  </div>

  <!-- Modal Container -->
  <div class="flex items-center justify-center min-h-screen p-4">
    <div [class]="modalClasses" @modalAnimation (click)="$event.stopPropagation()">

      <!-- Close Button -->
      <button
        *ngIf="showCloseButton"
        (click)="onClose()"
        type="button"
        class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Close">
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>

      <!-- Header avec icône -->
      <div *ngIf="title" class="mb-6">
        <div *ngIf="iconType" [class]="iconContainerClasses">
          <svg [class]="iconClasses" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="iconPath"/>
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 text-center">{{ title }}</h3>
        <p *ngIf="subtitle" class="text-sm text-gray-600 text-center mt-2">{{ subtitle }}</p>
      </div>

      <!-- Contenu personnalisé via ng-content -->
      <div class="mb-6">
        <ng-content></ng-content>
      </div>

      <!-- Actions (boutons) -->
      <div *ngIf="showPrimaryButton || showSecondaryButton" class="flex gap-3">
        <button
          *ngIf="showSecondaryButton && secondaryButtonText"
          (click)="onSecondaryAction()"
          type="button"
          [class]="'flex-1 px-4 py-2 rounded-lg transition-colors font-medium ' + secondaryButtonClass">
          {{ secondaryButtonText | translate }}
        </button>
        <button
          *ngIf="showPrimaryButton && primaryButtonText"
          (click)="onPrimaryAction()"
          type="button"
          [class]="'flex-1 px-4 py-2 rounded-lg transition-colors font-medium ' + primaryButtonClass">
          {{ primaryButtonText | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
